module.exports = __webpack_public_path__ + "static/media/social2.5926cf3b.png";